import { PaddingType } from 'common/types/styleTypes'
import { mobilePaddingsCss, paddingsCss } from 'common/utils/styleUtilsNew'
import styled from 'styled-components'

type BlogLatestPostsUiNewProps = {
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
}
const BlogLatestPostsUiNew = styled.div<BlogLatestPostsUiNewProps>`
  ${paddingsCss};
  ${p => p.theme.isEditorMobileMode && mobilePaddingsCss}
  ${p => p.theme.phone} {
    ${mobilePaddingsCss}
  }
`

export default BlogLatestPostsUiNew
